<div class="feature-selection">
  <div class="current-product">
    <span class="product-name">
      {{ product.name }}
    </span>
    <div class="spacer"></div>
  </div>
  <hr />

  <div class="flex-container">
    <mat-card class="selected-feature">
      <mat-card-header>
      </mat-card-header>

      <mat-card-content>
        <div class="feature-image">
          @if (selectedFeature.image && selectedFeature.image.mediumURL) {
            <img
              src="{{selectedFeature.image.mediumURL}}">
          }
        </div>

        <div class="feature-description"
          [innerHTML]="selectedFeature.description">
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="feature-group">
      <mat-card-header>
        <mat-card-title>
          <span class="product-name">
            {{ product.name }}
          </span>

          <span class="product-price">
            <price-display [price]="getCurrentPriceConfig(product.price, product.quantity)"
            [quantity]="product.quantity"></price-display>
          </span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-radio-group class="feature-selection-radio-group"
          [value]="featureGroup.selectedFeature"
          (change)="setSelectedFeature($event.value)">
          @for (feature of features; track trackById($index, feature)) {
            <mat-radio-button #featureRadioButton
              [value]="feature.id"
              [disabled]="!feature.inStock">
              <span class="radio-name-price"
                [ngClass]="{'disabled': featureRadioButton.disabled}">
                <span class="name">{{ feature.name }}</span>
                @if (feature.isPromoted) {
                  <div class="promotion-sign">
                    <img [src]="promotionSignUrl" />
                  </div>
                }
                <span class="price">
                  <price-display
                    [price]="getCurrentPriceConfig(feature.price, product.quantity)"
                    [display]="'hideOnZeroValue'"
                    [showAsAddition]="true"
                    [quantity]="product.quantity"
                  ></price-display>
                </span>
              </span>
            </mat-radio-button>
          }
        </mat-radio-group>
      </mat-card-content>
      <mat-card-footer>
        {{ 'i18n.price.total' | translate }}:
        <price-display
          [price]="priceCalculationService.productTotal"
          [display]="'reducedAmountOnly'"
        ></price-display>
      </mat-card-footer>
    </mat-card>
  </div>
</div>
